'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdChildFriendly = function MdChildFriendly(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 33.4c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-15 0c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m18.8-6.9c1.2 1.1 1.9 2.6 1.9 4.4 0 3.2-2.5 5.7-5.7 5.7-3 0-5.4-2.1-5.8-5h-3.5c-0.4 2.9-2.8 5-5.7 5-3.2 0-5.9-2.5-5.9-5.7 0-2.2 1.2-4.2 3-5.2-0.3-0.5-3.5-7.3-3.5-7.3h-3.6v-3.4h5.7l1.6 3.4h24.3c0 3-1.1 5.8-2.8 8.1z m-10.6-23.1c7.4 0 13.4 5.9 13.4 13.2h-13.4v-13.2z' })
        )
    );
};

exports.default = MdChildFriendly;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/child-friendly.js
// module id = 2930
// module chunks = 0